import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { LocalEstoque, TiposEstoque, TiposArmazem, enumTipoEstoque } from 'src/app/classes/LocalEstoque';
import { LocalEstoqueService } from 'src/app/services/local-estoque.service';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';
import { UtilsService } from 'src/app/utils/utils.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-local-estoque-forms',
  templateUrl: './local-estoque-forms.component.html',
  styleUrls: ['./local-estoque-forms.component.scss']
})
export class LocalEstoqueFormsComponent implements OnInit {
    @ViewChild('Modal', { static: false }) modal: UiModalComponent
    @ViewChild('formulario', { static: false }) formulario!: NgForm;
    @Output() finalizarSave: EventEmitter<void> = new EventEmitter()
    @Output() change: EventEmitter<boolean | void> = new EventEmitter()
    @Input() lista: LocalEstoque[] = []
    @Input() isSuper: boolean = false

    isSubmit: boolean = false
    item: LocalEstoque = new LocalEstoque()
    carregando: boolean = false
    int32MaxValue = 2147483647;
    tiposEstoque = TiposEstoque;
    tiposArmazem = TiposArmazem;
    tipoArmazem = enumTipoEstoque.Armazem;

  constructor(private localEstoquesService: LocalEstoqueService, 
              private utils: UtilsService) {
  }

  ngOnInit() {     
  }

  abrirModal(local: LocalEstoque = null): void {
    console.log(local);
    if(local === null && !this.utils.verificarPermissaoUsuario('IncluirLocalEstoque'))
      return;
    if(local !== null && !this.utils.verificarPermissaoUsuario('EditarLocalEstoque'))  
      return;
    if (local !== null){
      this.item = local
      this.change.emit(true)
    }
    else
      this.item = new LocalEstoque()

    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
    this.formulario.resetForm();
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
);
  }

  changeItem(): void{
    this.change.emit()
  }

  save(): void {
    this.carregando = true

    if (!this.validarForm()) return

    this.item.UsuarioCadastro = null
    this.item.UsuarioAlteracao = null
    if (this.item.Id) {
      this.localEstoquesService
        .putLocalEstoque(this.item.Id, this.item)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              'Local de Estoque alterado com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.localEstoquesService.postLocalEstoque(this.item).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess(
            'Local de Estoque cadastrado com sucesso!',
          )
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

    confirmExcluir(local: LocalEstoque): void{
      if(!this.utils.verificarPermissaoUsuario('ExcluirLocalEstoque'))
        return;
      Swal.fire({
        title: 'Você tem certeza desta ação?',
        text:
          'Deseja excluir este Local de Estoque?. Essa ação é irreversível!',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Excluir Local Estoque',
      }).then((response) => {
        if (!response.dismiss) {
          this.excluir(local);
        }
      })
    }

  excluir(local: LocalEstoque): void{
    this.carregando = true;

    this.localEstoquesService.deleteLocalEstoque(local.Id).subscribe(
      res => {
        this.utils.handleSuccess("Local de Estoque excluído com sucesso!")
        this.carregando = false;
        this.finalizarSave.emit()
      },
      err => {
        this.utils.getErro(err)
        this.carregando = false;
      }
    )
  }

  validarForm(): boolean {
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }
}
